import { create } from 'zustand';

type AuthState = {
  role: 'admin' | 'user' | 'manager' | string;
  setRole: (role: AuthState['role']) => void;
};

export const useAuthStore = create<AuthState>(set => ({
  role: 'admin', // default role
  setRole: role => {
    let normalized = role;
    if (
      typeof normalized === 'string' &&
      normalized.startsWith('[') &&
      normalized.endsWith(']')
    ) {
      normalized = normalized.slice(1, -1).toLowerCase(); // '[USER]' -> 'user'
    }
    set({ role: normalized });
  },
}));
